import React from 'react';
import Navigation from '../components/Navigation';
import '../styles/Shows.css';

function Shows() {
  const upcomingShows = [
    {
      date: 'February 7, 2025',
      location: 'Road House, Cave Creek, AZ',
      ticketLink: 'https://hideaway-usa.com/music/',
    },
    {
      date: 'February 28, 2025',
      location: 'xBk, Des Moines, IA',
      ticketLink: 'https://wl.seetickets.us/event/decoy-trio-jordan-beem-loveyoubye/624679?afflky=xBkLive',
    },
    {
      date: 'March 15, 2025',
      location: 'Ostrich Festival, Chandler, AZ',
      ticketLink: 'https://www.tixr.com/groups/ostrichfestival/events/ostrich-festival-weekend-1-125128?_gl=1*1uwwgak*_ga*NTAxMTg0MjQyLjE3NDE1NDcxMTk.*_ga_K4238EN35M*MTc0MTU0NzExOC4xLjEuMTc0MTU0NzM4Ny42MC4wLjA.&sort=RECOMMENDED&COL=7190&A=L',
    },
    {
      date: 'March 16, 2025',
      location: 'Ostrich Festival, Chandler, AZ',
      ticketLink: 'https://www.tixr.com/groups/ostrichfestival/events/ostrich-festival-weekend-1-125128?_gl=1*1uwwgak*_ga*NTAxMTg0MjQyLjE3NDE1NDcxMTk.*_ga_K4238EN35M*MTc0MTU0NzExOC4xLjEuMTc0MTU0NzM4Ny42MC4wLjA.&sort=RECOMMENDED&COL=7191&A=L',
    },
    {
      date: 'April 6, 2025',
      location: 'Wild West Fest, Maricopa, AZ',
      ticketLink: 'https://www.tixr.com/groups/wwmfest/events/wild-west-music-fest-132444?_gl=1*1ov8cub*_ga*MTkxODAxODcwNS4xNzQxNTQ3NTg2*_ga_7976NJP6NS*MTc0MTU0NzU4NS4xLjAuMTc0MTU0NzU4NS42MC4wLjA.&sort=RECOMMENDED&COL=6164&A=L',
    },
    {
      date: 'March 21, 2025',
      location: 'Road House, Cave Creek, AZ',
      ticketLink: 'https://hideaway-usa.com/music/',
    },
    {
      date: 'April 11, 2025',
      location: 'Last Exit Live, Phoenix, AZ',
      ticketLink: 'https://www.eventbrite.com/e/banana-gun-2-night-stand-tickets-1256231836239?aff=oddtdtcreator',
    },
    {
      date: 'May 2, 2025',
      location: 'Pour Decisions, Scottsdale, AZ',
      ticketLink: 'https://www.pourdecisionsscottsdale.com/',
    },
    {
      date: 'May 16, 2025',
      location: 'Road House, Cave Creek, AZ',
      ticketLink: 'https://hideaway-usa.com/music/',
    },
    {
      date: 'July 25, 2025, 7:00 PM',
      location: 'King Pigeon, Phoenix, AZ',
      ticketLink: 'https://www.instagram.com/kingpigeonthriftandvintage/?hl=en',
    },
    {
      date: 'September 5, 2025, 10:00 PM',
      location: 'Central Records, Phoenix, AZ',
      ticketLink: 'https://dtphx.org/go/central-records-hi-fi-cafe',
    },
    {
      date: 'September 18, 2025, 6:00 PM',
      location: 'Asante Library, Surprise, AZ',
      ticketLink: 'https://surpriseaz.gov/1165/Special-Events/1000?contentId=9ac9db76-5969-4479-bfa6-8c983aa9eef2',
    },
    {
      date: 'November 23, 2025, 6:30 PM',
      location: 'Rhythm Room, Phoenix, AZ',
      ticketLink: 'https://wl.eventim.us/event/pablo-and-the-pour-decisions/665909?afflky=RhythmRoom',
    },
    {
      date: 'December 7, 2025',
      location: 'Rebel Lounge, Phoenix, AZ',
      ticketLink: 'https://therebellounge.com/events/',
    },
    {
      date: 'December 20, 2025',
      location: 'Pour Decisions, Scottsdale, AZ',
      ticketLink: 'https://pourdecisionsscottsdale.com/',
    },
    {
      date: 'January 3, 2026',
      location: 'Linger Longer Lounge, Scottsdale, AZ',
      ticketLink: 'https://www.lingerlongerlounge.com/live-music',
    },
    {
      date: 'March 28, 2026',
      location: 'Hideway, Cave Creek, AZ',
      ticketLink: 'https://hideaway-usa.com/music/',
    },
    {
      date: 'May 9, 2026',
      location: 'Rips Bar, Phoenix, AZ',
      ticketLink: 'https://ripsbar.weebly.com/',
    },
    {
      date: 'May 29, 2026',
      location: 'Yucca Tap Roop, Tempe, AZ',
      ticketLink: 'https://yuccatap.com/events',
    },
        {
      date: 'June 27, 2026, 7:00 PM',
      location: 'Crescent Ballroom, Phoenix, AZ',
      ticketLink: 'https://www.ticketweb.com/event/chris-bowen-ep-release-with-crescent-ballroom-tickets/14909223?pl=crescent&REFID=clientsitewp',
    },
            {
      date: 'October 4, 2026, 5:00 PM',
      location: 'Rebel Lounge - DUSK BATTLE OF THE BANDS, Phoenix, AZ',
      ticketLink: 'https://wl.eventim.us/event/dusk-battle-of-the-bands/703927?afflky=TheRebelLounge',
    },
                {
      date: 'November 7, 2026, 6:30 PM',
      location: 'Marquee Theatre, Tempe, AZ',
      ticketLink: 'https://www.ticketmaster.com/event/1900650C8A93D596?did=loveyoubye',
      customDescription: "Tickets use code 'LOVE'"
    }

  ];
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  
  const filteredShows = upcomingShows.filter(show => {
    const showDate = new Date(show.date);
    showDate.setHours(0, 0, 0, 0);
    return showDate >= today;
  });

  return (
    <div className="page">
      <Navigation />
      <div className="content">
        <h1>Upcoming Shows</h1>
        <div className="shows-container">
          {filteredShows.length > 0 ? (
            filteredShows.map((show, index) => (
              <div key={index} className="show-card">
                <h2>{show.date}</h2>
                <p>{show.location}</p>
                <a href={show.ticketLink} target="_blank" rel="noopener noreferrer" className="ticket-button">
                  {show['Custom Description'] || show.customDescription || 'More Info/Tickets'}
                </a>
              </div>
            ))
          ) : (
            <p>No upcoming shows.</p>
          )}
        </div>
      </div>
    </div>
  );
}

export default Shows;
